export default __webpack_public_path__ + "static/media/bike-side-no-shadow.f421bf10.webp";